import { styled as muiStyled } from '@mui/material'

export function getBackgroundForPMPFirstSectionItems({ debug, debugColor, debugHighlightState }) {
  // No background colors - keep it clean and professional
  if (debugHighlightState) {
    return '#ff7c7c'
  }
  if (debug) {
    return debugColor || 'grey'
  }
  return 'transparent'
}

export const PMPBodySectionItems = muiStyled('div')(
  ({ theme, debug, debugColor, debugHighlight, noPadding, borderLeft, paddingLeft }) => `
    padding: ${noPadding ? '' : '10px 0px 0px 0px'};
    background-color: ${getBackgroundForPMPFirstSectionItems({
      debug,
      debugColor,
      debugHighlightState: debugHighlight,
    })};
    ${borderLeft ? `border-left: ${borderLeft};` : ''}
    ${paddingLeft ? `padding-left: ${paddingLeft};` : ''}
    transition: all 0.2s ease;
    
    /* Prevent content from overflowing footer */
    overflow: visible;
    word-wrap: break-word;
    word-break: break-word;
    
    /* Ensure proper page breaking for text content */
    @media print {
      page-break-inside: auto;
      orphans: 3;
      widows: 3;
    }
`,
)
export const PMPBodyDebugHighlightDiv = muiStyled('div')(
  ({ theme, debug, debugHighlight }) => `
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  top: 0;
    background-color: ${getBackgroundForPMPFirstSectionItems({
      debug,
      debugColor: 'transparent',
      debugHighlightState: debugHighlight,
    })};
`,
)
